import { render, staticRenderFns } from "./CouponCrudPage.vue?vue&type=template&id=38a61fd3"
import script from "./CouponCrudPage.vue?vue&type=script&lang=js"
export * from "./CouponCrudPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports